<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-contact-reaseons-black-list">
    <el-dialog
      title=""
      v-if="dialogBlackListVisible"
      :visible.sync="dialogBlackListVisible"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      append-to-body
      custom-class="black-list-dialog"
      :before-close="handleBlackListClose">
      <div v-loading="loading">
        <div @click="handleBlackListClose" class="dialogue-header"></div>
        <div class="div-black-list-title">Are you sure you want to move the selected Conversation Topics to the blacklist?</div>
        <div class="div-black-list-subtitle">Conversation Topics can be recovered from the blacklist through the configuration option in the side navigation.</div>
        <!-- <div class="div-black-list-subtitle"> These changes apply to all company users. You can edit the blacklist in <span class="config-setting-text" @click="handleConfigurationSettings">Configuration Settings</span>. </div> -->
        <!-- <div class="div-selected-black-list-topic-section">
          <div class="div-selected-black-list-topic-content" >
            <div class="div-item" :title="topic.topicDisplayName" v-for="(topic, index) in selectedBlackListTopicList" :key="index">
              <div class="div-ellipsis-item">{{topic.topicDisplayName}}</div> <i v-if="selectedBlackListTopicList && selectedBlackListTopicList.length > 1" class="el-icon-error" @click="removeTopic(index)"></i>
            </div>
          </div>
        </div> -->
        <div slot="footer" class="dialog-footer">
          <el-button class="btn-cancel" @click="handleBlackListClose">Cancel</el-button>
          <el-button class="btn-confirm" type="primary" @click="updateBlackList">Add to Blacklist</el-button>
          <br clear="all"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'wy-analytics-contact-reasons-black-list',
  props: ['controller'],
  data() {
    return {
      selectedBlackListTopicList: [],      
      dialogBlackListVisible: false,
      preMsgObj: null,
      loading: false
    }
  },

  methods: {
    ...mapActions(['updateContactReasonTopicBlackList']),

    handleBlackListClose() {
      this.dialogBlackListVisible = false;
    },

    handleBlackListOpen(selectedList) {
      this.selectedBlackListTopicList = selectedList;
      this.dialogBlackListVisible = true;
    },

    updateBlackList() {
      if(this.selectedBlackListTopicList.length > 0) {
        let topicsToBlacklist = [];
        this.selectedBlackListTopicList.forEach(el => {
          topicsToBlacklist.push({
            topicDisplayName: el.topicDisplayName,
            topicNames: el.mergedTopics
          });
        });
        this.handleUpdateBlackList(topicsToBlacklist);
      }
      else {
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 5000,
            showClose: true,
            customClass: 'blacklist-warning-msg',
            message: 'Must have at least one topic in blacklist.',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
    },

    async handleUpdateBlackList(topicsToBlacklist) {      
      this.loading = true;
      let res = await this.updateContactReasonTopicBlackList({topicsToBlacklist: topicsToBlacklist});
      this.loading = false;

      if(!res) {
        this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
      }
      else if(res.status == 200) {
        this.handleBlackListClose();
        this.$root.showProcessWaitDialogue({visible: true, processId: res.data.processId});
        this.$store.dispatch('amplitudeLogWithFilters', {name: 'topics_hidden', data: {topics_hidden: topicsToBlacklist}});
        
        if(this.controller.$refs.table) this.controller.$refs.table.clearSelection();
        if(this.controller.$refs.configTopicsTable) this.controller.$refs.configTopicsTable.clearSelection();
        if(this.controller.controller) this.controller.controller.isModified = true;
      }        
      else if(res.status == 409) {
        this.$root.showProcessErrorDialogue({controller: this, info: res.data});
      }
    },

    removeTopic(index) {
      if(this.selectedBlackListTopicList.length > 1) {
        this.selectedBlackListTopicList.splice(index, 1);
      }
      else {
        if(this.preMsgObj == null){
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 5000,
            showClose: true,
            customClass: 'blacklist-warning-msg',
            message: 'Must have at least one topic in blacklist.',
            onClose: ()=>{
              this.preMsgObj = null;
            }
          });
        }
      }
    },

    handleConfigurationSettings() {
      //todo
    },
  }
});
</script>

<style lang="scss">
.blacklist-warning-msg {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 3px 3px 12px #00000029;
  border: 2px solid #214586;
  border-radius: 10px;
  opacity: 1;
  background-image: url('../../assets/icons/alert_timed_out.svg');
  background-size: 9%;
  background-position-x: 17px;
  background-position-y: 11px;
  padding: 23px 15px 19px 24px;
  .el-message__icon {
    display: none;
  }
  .el-message__content {
    padding-left: 40px;
    font-size: 15px;
    color: var(--site-font-primary-color)
  }
}

.el-dialog.black-list-dialog {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: var(--site-dialog-primary-shadow);
  border-radius: 10px;
  opacity: 1;
  // margin-left: 690px;
  height: 227px;
  width: 785px !important;
  padding: 20px;
  .el-dialog__header {
    display: none;
  }
  .dialogue-header {
    background-image: var(--icon_close_popup) !important;
    background-size: 35px;
    background-repeat: no-repeat;
    background-position-y: -10px;
    cursor: pointer;
    background-position-x: 97%;
    height: 35px;
    width: 100%;
    text-align: center;
    padding: 0px 0px 0px 20px;
    font-weight: 600;
    margin-top: 5px;
  }
  .el-dialog__body {
    padding: 0px 0px 0px 0px;
    color: var(--site-font-primary-color);
    .div-topic-label{
      font-weight: 600;
    }
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
    margin-left: -10px;
  }
  .el-dialog__footer {
    padding: 0px;
  }

  .div-black-list-title {
    text-align: left;
    font-weight: 500;
    font-size: 18px;
    color: var(--site-font-tertiary-color);
  }
  .div-black-list-subtitle {
    text-align: left;
    font-size: 14.22px;
    margin: 26px 0px;
    color: var(--site-font-tertiary-color);
    line-height: 20px;
    font-weight: 400;
    .config-setting-text {
      color: #214586;
      cursor: pointer;
    }
  }
  .div-selected-black-list-topic-section {
    // padding: 15px 0px 0px 0px;
    // display: inline-block;
    .div-header {
      height: 20px;

      .header-title{
        margin-top: 2px;
        font-weight: 600;
        font-size: 14px;
        display: inline-block;
      }
      
      .btn-remove-all{
        padding: 4px 7px 5px 7px;
        font-size: 11px;
        height: 22px;
        border-radius: 10px;
        float: right;
      }

    }
    .div-selected-black-list-topic-content {
      height: 277px;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #FFF;
      padding: 7px 0px 7px 0px;
      margin-top: 5px;
      margin-bottom: 15px;
      // border-radius: 10px;
      // background: #FFFFFF 0% 0% no-repeat padding-box;
      // -webkit-box-shadow: 0px 3px 6px #00000029;
      // box-shadow: 0px 3px 6px #00000029;
      // border-radius: 8px;
      opacity: 1;

      .div-item {
        color: var(--site-font-primary-color);
        font-weight: normal;
        background-color: #FAFAFA;
        margin: 0px 0px 5px 0px;
        border-radius: 5px;
        line-height: 19px;
        padding: 8px 8px 5px 29px;
        font-size: 14px;
        font-weight: 500;
        
        .div-ellipsis-item {
          width: 88%;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .div-item:hover {
        background: #E2ECF7;
      }

      .el-icon-error{
        float: right;
        // display: none;
        top: 4px;
        left: -10px;
        position: relative;
        color: #80A6CD;
        cursor: pointer;
        font-size: 15px;
      }
      .el-icon-error.is-disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
      .div-item:hover .el-icon-error {
        display: block; 
      }
    }
  }
  div.dialog-footer {
    margin-top: 36px;
    position: relative;
    right: 20px;
    display: flex;
    height: 61px;
    width: 105.4%;
    // border-top: 1px solid #CAD2DB;
    justify-content: flex-end;
    align-items: center;
    .btn-cancel {
      float: left;
      border: 1px solid transparent;
      height: 33px;
      color: var(--site-button-cancel-btn-primary-color) !important;
      padding: 7px 20px 7px 20px;
    }
    .btn-cancel:hover {
      background-color: transparent;
    }
    .btn-cancel:focus {
      background-color: transparent;
    }
    .btn-discard {
      border: 1px solid #CAD2DB;
      border-radius: 4px !important;
      height: 33px;
      padding: 7px 20px 7px 20px;
      color: var(--site-button-cancel-btn-primary-color) !important;
    }
    .btn-confirm {
      float: right;
      padding: 8px 16px 8px 16px;
      background: var(--site-button-primary-btn-background-primary-color);
      color: var(--site-button-primary-btn-text-primary-color) !important;
      border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
      font-size: 15px;
      cursor: pointer;
      font-family: Helvetica Neue, Arial, sans-serif;
      border-radius: 5px;
      margin-right: 19px;
    }
    .btn-confirm:hover {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .btn-confirm:active {
      background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
    }
    .btn-confirm:focus {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }

    .btn-confirm.disabled {
      color: var(--site-button-primary-btn-text-primary-color) !important;
      cursor: not-allowed;
    }
  }

  .el-input__inner:focus {
    border-color: #214586;
  }
}

.el-popup-parent--hidden {
  padding-right: 0px !important;
}
</style>